enum WorkspaceProjectBlockStatus {
  draft = 'draft',
  active = 'active',
  deleted = 'deleted',
}

export default WorkspaceProjectBlockStatus
